import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title } from 'common/components/layout';
import { isPreSale } from 'common/helpers/featureFlags';
import SubMenu from 'profile/common/SubMenu';
import { getClubMembership } from 'redux/clubMemberships/actions';

import ClubMembershipDisplay from './list/ClubMembershipDisplay';

class ClubMembershipEdit extends Component {
  componentDidMount() {
    const { props } = this;
    const { id } = props.match.params;
    props.getClubMembership(id);
  }

  render() {
    const { props } = this;
    const { id } = props.match.params;
    const { settings, clubMemberships } = this.props;
    if (!settings.data || !clubMemberships.data) {
      return (
        <Layout title="Edit Club Membership" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }
    let title = 'Club Membership';
    if (isPreSale()) {
      title = 'Pre-Sale Selection';
    }
    const clubMembership = clubMemberships.data[id];
    return (
      <Layout title="Edit Club Membership">
        <Title>Your Account</Title>
        <SubMenu />
        <div className="c7-account__clubs">
          <h2>Edit {title}</h2>
          <ClubMembershipDisplay clubMembership={clubMembership} />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  clubMemberships: state.clubMembership,
  settings: state.setting
});

export default connect(mapStateToProps, {
  getClubMembership
})(ClubMembershipEdit);
